import { CountryID, CountryCode, LanguageId, LanguageCode, CurrencyCode } from "./enums";

/**
 * 国家默认信息
 */
export const countryMap = {
  // 印尼
  [CountryCode.ID]: {
    countryId: CountryID.ID,
    countryCode: CountryCode.ID,
    currencyCode: CurrencyCode.ID,
    languageCode: LanguageCode.in,
    languageId: LanguageId.in,
  },
  // 马来
  [CountryCode.MY]: {
    countryId: CountryID.MY,
    countryCode: CountryCode.MY,
    currencyCode: CurrencyCode.MY,
    languageCode: LanguageCode.ms,
    languageId: LanguageId.ms,
  },
  // 菲律宾
  [CountryCode.PH]: {
    countryId: CountryID.PH,
    countryCode: CountryCode.PH,
    currencyCode: CurrencyCode.PH,
    languageCode: LanguageCode.en,
    languageId: LanguageId.en,
  },
  // 越南
  [CountryCode.VN]: {
    countryId: CountryID.VN,
    countryCode: CountryCode.VN,
    currencyCode: CurrencyCode.VN,
    languageCode: LanguageCode.vi,
    languageId: LanguageId.vi,
  },
  // 中国
  [CountryCode.CHN]: {
    countryId: CountryID.CHN,
    countryCode: CountryCode.CHN,
    currencyCode: CurrencyCode.CHN,
    languageCode: LanguageCode.zh,
    languageId: LanguageId.zh,
  },
  // 德国
  [CountryCode.DE]: {
    countryId: CountryID.DE,
    countryCode: CountryCode.DE,
    currencyCode: CurrencyCode.DE,
    languageCode: LanguageCode.de,
    languageId: LanguageId.de,
  },
  // 西班牙
  [CountryCode.ES]: {
    countryId: CountryID.ES,
    countryCode: CountryCode.ES,
    currencyCode: CurrencyCode.ES,
    languageCode: LanguageCode.es,
    languageId: LanguageId.es,
  },
};
